module.exports = __webpack_public_path__ + "img/default.189a05f3.png";